/* LUMECART theme scripts */
(function () {
  'use strict';

  var Theme = window.Theme || {};

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = Theme.moneyFormat || '${{amount}}';
    var value = '';

    function withDelimiters(num, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num === null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- mobile nav ---------- */
  var nav = document.querySelector('[data-mobile-nav]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) { nav && nav.classList.add('is-open'); }
    if (e.target.closest('[data-nav-close]')) { nav && nav.classList.remove('is-open'); }
  });

  /* ---------- cart drawer ---------- */
  var drawerBody = document.querySelector('[data-drawer-body]');
  var drawerFoot = document.querySelector('[data-drawer-foot]');

  function openDrawer() { document.body.classList.add('drawer-open'); }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); refreshCart(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!drawerBody) return;

    if (!cart.items.length) {
      drawerBody.innerHTML =
        '<div class="empty"><p>Your bag is empty.</p>' +
        '<a class="btn btn--ghost" href="/collections/all">Start shopping</a></div>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_200x$1') + '" alt="" loading="lazy">'
        : '<div class="dline__ph"></div>';
      var opts = item.options_with_values && item.options_with_values.length && item.product_has_only_default_variant === false
        ? '<div class="dline__opt">' + item.options_with_values.map(function (o) { return o.value; }).join(' / ') + '</div>'
        : '';
      html +=
        '<div class="dline">' + img +
        '<div style="flex:1">' +
        '<a class="dline__name" href="' + item.url + '">' + item.product_title + '</a>' + opts +
        '<div class="price" style="margin-bottom:10px">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="dline__actions">' +
        '<div class="qty">' +
        '<button type="button" data-line-change="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
        '<button type="button" data-line-change="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="dline__remove" data-line-change="' + (i + 1) + '" data-to="0">Remove</button>' +
        '</div></div></div>';
    });
    drawerBody.innerHTML = html;

    if (drawerFoot) {
      drawerFoot.hidden = false;
      var totalEl = drawerFoot.querySelector('[data-drawer-total]');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    var line = parseInt(btn.getAttribute('data-line-change'), 10);
    var to = parseInt(btn.getAttribute('data-to'), 10);
    if (isNaN(to) || to < 0) return;
    btn.disabled = true;
    fetch(Theme.changeUrl || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: to })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (document.body.classList.contains('template--cart')) window.location.reload();
      });
  });

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    var original = submit ? submit.textContent : '';
    if (submit) { submit.disabled = true; submit.textContent = 'Adding\u2026'; }

    fetch(Theme.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Could not add to bag');
        return refreshCart().then(openDrawer);
      })
      .catch(function (err) {
        var msg = form.querySelector('[data-form-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .then(function () {
        if (submit) { submit.disabled = false; submit.textContent = original; }
      });
  });

  /* ---------- product variants ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var addBtn = root.querySelector('[data-add-button]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked') || group.querySelector('select');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var chosen = selected();
      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];

      root.querySelectorAll('[data-option-current]').forEach(function (el, i) {
        if (chosen[i]) el.textContent = chosen[i];
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price > match.price
          ? '<del>' + formatMoney(match.compare_at_price) + '</del><ins>' + formatMoney(match.price) + '</ins>'
          : formatMoney(match.price);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', update);
    update();
  });

  /* ---------- quantity steppers on page ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
  });

  /* ---------- gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !main) return;
      main.innerHTML = '<img src="' + thumb.getAttribute('data-full') + '" alt="' + (thumb.getAttribute('data-alt') || '') + '">';
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- init ---------- */
  refreshCart();
  document.addEventListener('shopify:section:load', function () { refreshCart(); });
})();
